import React from "react";
import {Link} from "react-router-dom";
import image from "./favicon-32x32.png"
import SearchForm from "../SearchForm";
import {FaHome, FaStar, FaHeart, FaTh, FaQuestion} from "react-icons/fa";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

function Navigation() {
    return (
        <div className="Navigation mb-4">
            <Navbar bg="dark" expand="lg" variant="dark">
                <Navbar.Brand href="/"> <img className="ml-3" src={image} alt="Foto"/> Sound Explorer</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item active">
                                <Link className="nav-link" to="/"><span
                                    className="align-text-bottom"><FaHome/></span> HOME<span
                                    className="sr-only">(current)</span></Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/mysounds"><span className="align-text-bottom"><FaStar/></span> MY
                                    SOUNDS</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/bookmarks"><span
                                    className="align-text-bottom"><FaHeart/></span> BOOKMARKS</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/explorer"><span
                                    className="align-text-bottom"><FaTh/></span> EXPLORER</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="/about"><span className="align-text-bottom"><FaQuestion/></span> ABOUT</Link>
                            </li>
                        </ul>
                    </Nav>
                    <SearchForm/>

                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}

export default Navigation;